const btnNewActionPost = {
  text: 'To send'
};

export default btnNewActionPost;
